<template>
<div>

    <el-crud :baseUrl="'/costcenters'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        :filters="filters"
        ref="crud">


        <template slot="crudFiltersDescription">
            <div v-if="filters.filter">Centro de Costo: <strong>{{filters.filter}}</strong></div>
            <div v-if="!areFilters"><strong>Datos sin filtrar</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Centro de Costo" label-width="120px" prop="filter">
                        <el-input placeholder="Código o nombre" v-model="filters.filter" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>


        <template slot="table">
            <el-table-column
                prop="company_id_number"
                label="Cód.">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Nombre">
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Código" label-width="120px" :prop="resource.company_id_number" :error="scope.errors.company_id_number">
                <el-input v-model="resource.company_id_number" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Nombre" label-width="120px" :prop="resource.description" :error="scope.errors.description">
                <el-input v-model="resource.description" auto-complete="off" size="mini"></el-input>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nuevo Centro de Costo',
                    EditItemTitle: 'Editar Centro de Costo',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el centro de costo. Desea continuar?'
                },
                filters: {
                    filter: null,
                },
                resource:{
                    company_id_number: null,
                    description: null,
                },
            }
        },
        computed: {
            'areFilters': function () {
                return this.filters.filter != null;
            }
        },
        components: {
            'el-crud': el_crud,
        },
    }
</script>
